export const OVERLAY_PATH = 'https://web-native-display-campaign.clevertap.com/production/lib-overlay/overlay.js'
export const CSS_PATH = 'https://web-native-display-campaign.clevertap.com/production/lib-overlay/style.css'
export const WVE_CLASS = {
  FLICKER_SHOW: 'wve-anti-flicker-show',
  FLICKER_HIDE: 'wve-anti-flicker-hide',
  FLICKER_ID: 'wve-flicker-style'
}
export const WVE_QUERY_PARAMS = {
  BUILDER: 'ctBuilder',
  PREVIEW: 'ctBuilderPreview',
  SDK_CHECK: 'ctBuilderSDKCheck'
}

export const WVE_URL_ORIGIN = {
  CLEVERTAP: 'dashboard.clevertap.com',
  LOCAL: 'localhost'
}
